/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ReferralSettlementApi } from '../api/referralSettlement.api';
import { ReferralSettlementData, ReferralSettlement } from '../../../interfaces/masters/referralsettlement';

@Injectable()
export class ReferralSettlementService extends ReferralSettlementData {
  
  constructor(private api: ReferralSettlementApi) {
    super();
  }

  list(url: string): Observable<ReferralSettlement[]> {
    return this.api.list(url);
  }
  configList(url: string): Observable<any[]> {
    return this.api.list(url);
  }
  searchList(url: string, data:any): Observable<ReferralSettlement[]> {
    return this.api.searchList(url,data);
  }
  referalTransList(url: string, data:any): Observable<any[]> {
    return this.api.referalTransList(url,data);
  }

  create(url: string, data:ReferralSettlement[]): Observable<any> {
    return this.api.add(url,data);
  }
  bulkCreate(url: string, data:any[]): Observable<any> {
    return this.api.bulkAdd(url,data);
  }

  update(url: string, data:any): Observable<any> {
    return this.api.update(url,data);
  }

}
